import React from "react";
import { Loader2 } from "lucide-react";
import LeadRow from "./LeadRow";

export default function LeadsTable({ loading, leads, onRowClick }) {
  return (
    <div className="card">
      {loading && (!leads || leads.length === 0) ? (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                {[...Array(6)].map((_, i) => (
                  <th key={i}>
                    <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, i) => (
                <tr key={i}>
                  {[...Array(6)].map((_, j) => (
                    <td key={j}>
                      <div className="h-4 w-full bg-gray-100 rounded animate-pulse" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className={`table-wrapper ${loading ? 'opacity-50 transition-opacity duration-200' : ''}`}>
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Segment</th>
                <th>Total Value</th>
                <th>Status</th>
                <th>Commission</th>
                <th>Products</th>
              </tr>
            </thead>
            <tbody>
              {leads?.map((l) => (
                <LeadRow key={l.id} lead={l} onClick={onRowClick} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

